export default __webpack_public_path__ + "static/media/576.caa5627a.gif";